import React, { useEffect, useState, useRef } from "react";
import {
  Divider,
  Button,
  TextField,
  Grid,
  Stack,
  InputLabel,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import styles from "./../ParameterForm.module.scss";
import { useDispatch } from "react-redux";
import { labelTypeActions } from "../../../../../../actions";
import { useStyles } from "../../../../../../Theme/Style";

const LabelType = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { title, titleSingle, mode, paramdata, handleSuccessDialog } = props;
  const debug = false;
  const [submitting, setSubmitting] = useState(false);
  const successMsg = "";
  const formikRef = useRef(null);

  const isEditMode = mode === "edit";

  const validationSchema = Yup.object({
    labelname: Yup.string().required("Label Type Name is required"),
  });

  // Local initial values state (so we can update it when paramdata arrives)
  const [initialValues, setInitialValues] = useState({
    labelname: "",
  });

  useEffect(() => {
    if (isEditMode && paramdata) {
      setInitialValues({
        labelname: paramdata.name || "",
      });
    }
  }, [isEditMode, paramdata]);

  const handleSubmit = (values) => {
    setSubmitting(true);

    if (isEditMode) {
      // 🔁 UPDATE
      dispatch(
        labelTypeActions.updateParameter(
          paramdata.id,
          values.labelname,
          handleSuccessDialog(successMsg),
          successMsg
        )
      );
    } else {
      // ➕ ADD
      dispatch(
        labelTypeActions.addParameter(
          values.labelname,
          handleSuccessDialog(successMsg), 
          successMsg
        )
      );
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={formikRef}
        enableReinitialize={true} // ⭐ important for edit mode
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);

          if (!isEditMode) {
            // usually we don't reset form after edit
            resetForm();
          }
        }}
      >
        {({
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
        }) => (
          <Form noValidate autoComplete="off">
            <Grid container spacing={{ xs: 2, sm: 2 }} sx={{ pt: 0, pb: 0 }}>
              <Grid item xs={12} md={6}>
                <InputLabel id="labelname-label">Label Type Name</InputLabel>
                <TextField
                  fullWidth
                  id="labelname"
                  name="labelname"
                  value={values.labelname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.labelname && Boolean(errors.labelname)}
                  helperText={touched.labelname && errors.labelname}
                  variant="outlined"
                  className={styles.textField}
                  size="small"
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Stack
                direction="column-reverse"
                justifyContent="space-between"
                align-items="center"
                sx={{
                  flexDirection: {
                    sm: "row",
                  },
                  mt: 2,
                }}
              >
                <Link to="../" style={{ display: "block" }}>
                  <Button
                    size="medium"
                    startIcon={<ArrowBackIcon size="small" />}
                    sx={{ textTransform: "none" }}
                  >
                    Back to {title}
                  </Button>
                </Link>

                <span style={{ flex: 1 }}>&nbsp;</span>

                <LoadingButton
                  color="secondary"
                  variant="contained"
                  fullWidth
                  type="submit"
                  size="large"
                  loading={submitting}
                  sx={{
                    width: {
                      xs: "100%",
                      md: "auto",
                    },
                  }}
                >
                  {isEditMode
                    ? `Update ${titleSingle}`
                    : `Save ${titleSingle}`}
                </LoadingButton>
              </Stack>
            </Grid>

            {debug && (
              <>
                <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                <pre style={{ textAlign: "left" }}>
                  <strong>Values</strong>
                  <br />
                  {JSON.stringify(values, null, 2)}
                </pre>
                <pre style={{ textAlign: "left" }}>
                  <strong>Errors</strong>
                  <br />
                  {JSON.stringify(errors, null, 2)}
                </pre>
              </>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default LabelType;
